import * as Types from './graphql.generated';

import { gql } from '@apollo/client';
export type AreaFragment = { __typename?: 'Area' } & Pick<
    Types.Area,
    'geoType' | 'shortName'
> & { longName: Types.Area['name'] };

export const AreaFragmentDoc = gql`
    fragment Area on Area {
        geoType
        longName: name
        shortName
    }
`;
